import FlagNeedsList from "../models/FlagNeedsList";

const FlagNeedsStore = FlagNeedsList.create({
  flagNeeds: [],
  sortColumn: "userName",
  sortOrder: "descend"
});

export default FlagNeedsStore;
